import { CallApiOptions } from './api';
import { uniq } from 'ramda';
export const fetchOutfitsCallOptions = (
  appId: number,
  outfitIds: number[]
): CallApiOptions => ({
  method: 'GET',
  endpoint: `proxies/mobile/${appId}/outfits/${uniq(outfitIds).join(',')}`,
});



// WEBPACK FOOTER //
// ./src/services/outfits.services.ts